import React, { Component } from "react";
import { FormGroup, RefForward } from "semantic-ui-react";
import { Button, Modal, ControlLabel, FormControl } from "react-bootstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import TimeStamp from "react-timestamp";
import _ from "lodash";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import Multiselect from "react-widgets/lib/Multiselect";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";

// Css
import "../../assets/css/groupmanagement.css";

// Image
import userIcon from "../../assets/img/groupmanagement/users_icon.png";
import grantAccess from "../../assets/img/Grant_Access_black.png";
import lockIcon from "../../assets/img/groupmanagement/locks_icon.png";

import LocalizedStrings from "react-localization";
import { bool } from "prop-types";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    accessedTrue: "Yes",
    accessedFalse: "No",
    accessHeader: "Access period",
    dailyHeader: "Daily access",
    Header: "Info",
    multiApprovalListLabel: "Multi Approval List",
    multiApprovalLabel: "Multi Approval Admin(s):",
    sharedOnLabel: "Shared on:",
    shareToLabel: "Share to:",
    startLabel: "Starts on:",
    endLabel: "Ends on:",
    startTimeLabel: "Start time:",
    endTimeLabel: "End time:",
    lockLabel: "Lock name:",
    timeLabel: "Timed Access:",
    accessedLabel: "Accessed:",
    statusHeader: "Approval Status",
    remarkHeader: "Remarks",
    emailHeader: "Admin Email",
    normalGrantAccess: "Normal Grant Access",
    recurringGrantAccess: "Recurring Grant Access",
    recurringTimedGrantAccess: "Recurring Timed Grant Access",
    recurringSchedule: "Schedule",
    recurringTimeLabel1: " to ",
    recurringTimeLabel2: "",
    multiApproveAccess: "Multi Approve Access",
    multiApproveOneTimeAccess: "Multi Approve & One Time Access",
    oneTimeAccess: "One Time Access",
    fullAccess: "All-day Access",
    noDataTitle: "There is no data to display",
    PopupButtonClose: "Close",
    pendingStatus: "Pending",
    approvedStatus: "Approved",
    deniedStatus: "Denied",
    recurringDaySun: "Sun",
    recurringDayMon: "Mon",
    recurringDayTue: "Tue",
    recurringDayWed: "Wed",
    recurringDayThu: "Thu",
    recurringDayFri: "Fri",
    recurringDaySat: "Sat",
  },
  ja: {
    accessedTrue: "アクセス履歴有",
    accessedFalse: "アクセス履歴無",
    accessHeader: "アクセス期間",
    dailyHeader: "アクセス時間",
    Header: "詳細",
    multiApprovalListLabel: "マルチ承認リスト",
    multiApprovalLabel: "マルチ承認（承認者アカウント）:",
    sharedOnLabel: "承認日:",
    shareToLabel: "共有アカウント:",
    endHeader: "アクセス終了日",
    startLabel: "開始日:",
    endLabel: "終了日:",
    startTimeLabel: "開始時間:",
    endTimeLabel: "終了時間:",
    lockLabel: "ロック名:",
    timeLabel: "タイムアクセス:",
    accessedLabel: "アクセス状況:",
    statusHeader: "承認状況",
    remarkHeader: "詳細",
    emailHeader: "承認者アカウント",
    normalGrantAccess: "アクセス譲渡",
    recurringGrantAccess: "曜日設定（アクセススケジュール）",
    recurringTimedGrantAccess: "曜日・時間設定",
    recurringSchedule: "設定スケジュール",
    recurringTimeLabel1: " から ",
    recurringTimeLabel2: "まで",
    multiApproveAccess: "承認者追加",
    multiApproveOneTimeAccess: "承認者追加＆ワンタイム解錠",
    oneTimeAccess: "ワンタイム解錠",
    fullAccess: "アクセス制限無し",
    noDataTitle: "表示するデータがありません。",
    PopupButtonClose: "Close",
    pendingStatus: "承認待ちの",
    approvedStatus: "承認を許可する",
    deniedStatus: "承認を拒否する",
    recurringDaySun: "日",
    recurringDayMon: "月",
    recurringDayTue: "火",
    recurringDayWed: "水",
    recurringDayThu: "木",
    recurringDayFri: "金",
    recurringDaySat: "土",
  },
  es: {
    accessedTrue: "Sí",
    accessedFalse: "No",
    accessHeader: "Período de Acceso",
    dailyHeader: "Acceso Diario",
    Header: "Información",
    multiApprovalListLabel: "Lista de Aprobación Múltiple",
    multiApprovalLabel: "Administradores de Aprobación Múltiple:",
    sharedOnLabel: "Compartido en:",
    shareToLabel: "Compartir a:",
    startLabel: "Comienza en:",
    endLabel: "Termina en:",
    startTimeLabel: "Hora de inicio:",
    endTimeLabel: "Hora de finalización:",
    lockLabel: "Nombre de la candado:",
    timeLabel: "Acceso Programado:",
    accessedLabel: "Accedido:",
    statusHeader: "Estado de Aprobación",
    remarkHeader: "Comentarios",
    emailHeader: "Correo Electrónico del Administrador",
    normalGrantAccess: "Acceso Normal",
    recurringGrantAccess: "Acceso Recurrente",
    recurringTimedGrantAccess: "Acceso Recurrente Programado",
    recurringSchedule: "Horario",
    recurringTimeLabel1: " a ",
    recurringTimeLabel2: "",
    multiApproveAccess: "Acceso de Aprobación Múltiple",
    multiApproveOneTimeAccess: "Aprobación Múltiple y Acceso Único",
    oneTimeAccess: "Acceso Único",
    fullAccess: "Acceso Todo el Día",
    noDataTitle: "No hay datos para mostrar",
    PopupButtonClose: "Cerrar",
    pendingStatus: "Pendiente",
    approvedStatus: "Aprobado",
    deniedStatus: "Denegado",
    recurringDaySun: "Dom",
    recurringDayMon: "Lun",
    recurringDayTue: "Mar",
    recurringDayWed: "Mié",
    recurringDayThu: "Jue",
    recurringDayFri: "Vie",
    recurringDaySat: "Sáb",
  },
});

export class MultiApprovalInfo extends Component {
  constructor(props) {
    super(props);

    const cell = this.props.cellValue || {};
    const row = this.props.rowValue || {};
    const access = row.access || {};

    this.state = {
      _notificationSystem: null,
      cell: cell,
      row: row,
      showPopup: false,
      key: row.key,
      name: row.name,
      lockSerial: row.lockSerial,
      shareto: row.shareto,
      start: row.start,
      end: row.end,
      shareMode: row.shareMode,
      isSuperAdmin: false,
      isAdmin: false,
      superAdminID: "",
      multiApprovalAdmins: [],
      access: access,
      sharedOn: isNaN(access.sharedOn) ? 0 : access.sharedOn * 1000,
    };

    this.handleMultiApprovalInfoPopupOpen = this.handleMultiApprovalInfoPopupOpen.bind(
      this,
    );
    this.handleMultiApprovalInfoPopupClose = this.handleMultiApprovalInfoPopupClose.bind(
      this,
    );
    this.getSelectedDays = this.getSelectedDays.bind(this);
    this.getAccessTime = this.getAccessTime.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    let row = nextProps.rowValue || {};

    this.setState({
      cell: nextProps.cellValue,
      row: nextProps.rowValue,
      key: row.key,
      name: row.name,
      lockSerial: row.lockSerial,
      shareto: row.shareto,
      start: row.start,
      end: row.end,
      shareMode: row.shareMode,
      access: row.access || {},
    });
  }

  async componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    await fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((superAdmin) => {
            const superAdminData = superAdmin.val();

            const memberDetails = superAdminData.members;

            for (let eachMemberId in memberDetails) {
              const eachMemberDetails = memberDetails[eachMemberId];
              const eachMemberEmail = eachMemberDetails.memberEmail;

              if (eachMemberEmail === auth.currentUser.email) {
                const superAdminID = superAdmin.key;
                this.setState({
                  isAdmin: eachMemberDetails.isAdmin,
                  isSuperAdmin: eachMemberDetails.isSuperAdmin,
                  superAdminID: superAdminID,
                });
              }
            }
          });
        }
      });

    const recordKey = this.state.key;

    if (!recordKey) {
      console.error("MultiApprovalInfo skipped: missing row key", {
        row: this.state.row,
        cell: this.state.cell,
      });
      return;
    }

    // get Multi approval selectedAdmins
    fire
      .database()
      .ref("retractableSharingRegistry")
      .child(auth.currentUser.uid)
      .child(recordKey)
      .once("value")
      .then(async (snapshot) => {
        if (snapshot.exists()) {
          let selectedAdmins = [];
          let hasAccessed = snapshot.val().hasAccessed;

          await fire
            .database()
            .ref("retractableSharingRegistry")
            .child(auth.currentUser.uid)
            .child(recordKey)
            .child("multiSharingAdmins")
            .once("value")
            .then((admins) => {
              admins.forEach((admin) => {
                selectedAdmins.push({
                  adminEmail: admin.val().adminEmail,
                  access: admin.val(),
                });
              });
            });

          this.setState({
            multiApprovalAdmins: selectedAdmins,
            hasAccessed: hasAccessed,
          });
        } else {
          let selectedAdmins = [];

          await fire
            .database()
            .ref("retractableSharingRegistry")
            .child(auth.currentUser.uid)
            .child(recordKey)
            .child("multiSharingAdmins")
            .once("value")
            .then((admins) => {
              admins.forEach((admin) => {
                selectedAdmins.push({
                  adminEmail: admin.val().adminEmail,
                  access: admin.val(),
                });
              });
            });

          this.setState({
            multiApprovalAdmins: selectedAdmins,
            hasAccessed: false,
          });
        }
      });
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  renderStatus(access) {
    if (access.remark !== null && access.remark !== undefined) {
      if (access.hasAllowed) {
        return localizationStrings.approvedStatus;
      } else {
        return localizationStrings.deniedStatus;
      }
    } else {
      return localizationStrings.pendingStatus;
    }
  }

  renderRemarks(access) {
    if (access.remark !== null && access.remark !== undefined) {
      return access.remark;
    }
  }

  showNotification(msg, lvl, position, duration) {
    //var level = lvl; // 'success', 'warning', 'error' or 'info'
    this.state._notificationSystem.addNotification({
      title: (
        <span
          data-notify="icon"
          className={
            lvl === "success"
              ? "pe-7s-check"
              : lvl === "error"
              ? "pe-7s-attention"
              : "pe-7s-bell"
          }
        ></span>
      ),
      message: <div>{msg}</div>,
      level: lvl,
      position: position,
      autoDismiss: duration,
    });
  }

  handleMultiApprovalInfoPopupOpen() {
    this.setState({
      showPopup: true,
    });
  }

  handleMultiApprovalInfoPopupClose() {
    this.setState({
      showPopup: false,
    });
  }

  getShareModeIcon(shareMode) {
    // normal access
    if (
      shareMode === "" ||
      shareMode === "NORMAL" ||
      shareMode === "NORMAL-GRP" ||
      shareMode == null
    ) {
      return (
        <img src={grantAccess} alt="grant_access" width="70px" height="70px" />
      );
    } else if (shareMode === "MULTI" || shareMode === "MULTI-GRP") {
      return <img src={userIcon} alt="user_image" width="70px" height="70px" />;
    } else if (shareMode === "MULTI-OTA" || shareMode === "MULTI-OTA-GRP") {
      return <img src={userIcon} alt="user_image" width="70px" height="70px" />;
    } else if (shareMode === "OTA" || shareMode === "OTA-GRP") {
      return (
        <img src={grantAccess} alt="grant_access" width="70px" height="70px" />
      );
    }
    // recurring access
    else if (
      shareMode === "NORMAL-RECURR" ||
      shareMode === "NORMAL-RECURR-GRP" ||
      shareMode === "NORMAL-RECURR-TIMED" ||
      shareMode === "NORMAL-RECURR-TIMED-GRP"
    ) {
      return (
        <img src={grantAccess} alt="grant_access" width="70px" height="70px" />
      );
    }
  }

  getOneTimeAccess(hasAccessed) {
    if (
      this.state.shareMode != undefined
        ? this.state.shareMode.includes("OTA")
        : false
    ) {
      return (
        <div style={{ display: "flex", width: "100%" }}>
          <div
            className="groupDetailsLabel"
            style={{ width: "45%", paddingRight: "30px" }}
          >
            <p>{localizationStrings.accessedLabel}</p>
          </div>
          <div className="groupDetailsText" style={{ width: "55%" }}>
            <p>
              {hasAccessed === true
                ? localizationStrings.accessedTrue
                : localizationStrings.accessedFalse}
            </p>
          </div>
        </div>
      );
    }
  }

  getSelectedDays(day, type) {
    let recurringDays = this.state.access.recurringDays;
    let selected = false;

    recurringDays.forEach((selection) => {
      if (selection === day) {
        selected = true;
      }
    });

    if (type === "bgColor") {
      if (selected) {
        return "#429ff4";
      } else {
        return "#f7f7f7";
      }
    } else if (type === "fontColor") {
      if (selected) {
        return "white";
      } else {
        return "grey";
      }
    } else if (type === "display") {
      if (selected) {
        return "";
      } else {
        return "none";
      }
    }
  }

  getAccessTime() {
    let access = false;
    this.state.access.selectedRecurringTime.startTime != undefined
      ? (access = true)
      : (access = false);

    if (access) {
      return (
        <div>
          <div style={{ marginBottom: "10px" }}>
            <span
              style={{
                marginTop: "0px",
                marginBottom: "0px",
                fontWeight: "bold",
                fontSize: "23px",
              }}
            >
              {localizationStrings.dailyHeader}
            </span>
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <div
              className="groupDetailsLabel"
              style={{ width: "45%", paddingRight: "30px" }}
            >
              <p>{localizationStrings.startTimeLabel}</p>
            </div>
            <div className="groupDetailsText" style={{ width: "55%" }}>
              <p>
                {this.timeFormat(
                  (this.state.access.selectedRecurringTime.startTime -
                    this.state.access.selectedRecurringTime.offset +
                    1800) *
                    1000,
                )}
              </p>
            </div>
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <div
              className="groupDetailsLabel"
              style={{ width: "45%", paddingRight: "30px" }}
            >
              <p>{localizationStrings.endTimeLabel}</p>
            </div>
            <div className="groupDetailsText" style={{ width: "55%" }}>
              <p>
                {this.timeFormat(
                  (this.state.access.selectedRecurringTime.endTime -
                    this.state.access.selectedRecurringTime.offset +
                    1800) *
                    1000,
                )}
              </p>
            </div>
          </div>
        </div>
      );
    }
  }

  getShareTime(start, end) {
    if (this.state.start != 0) {
      return (
        <div>
          <div style={{ marginBottom: "10px" }}>
            <span
              style={{
                marginTop: "0px",
                marginBottom: "0px",
                fontWeight: "bold",
                fontSize: "23px",
              }}
            >
              {localizationStrings.accessHeader}
            </span>
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <div
              className="groupDetailsLabel"
              style={{ width: "45%", paddingRight: "30px" }}
            >
              <p>{localizationStrings.startLabel}</p>
            </div>
            <div className="groupDetailsText" style={{ width: "55%" }}>
              <p>{this.dateTimeFormat(start * 1000)}</p>
            </div>
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <div
              className="groupDetailsLabel"
              style={{ width: "45%", paddingRight: "30px" }}
            >
              <p>{localizationStrings.endLabel}</p>
            </div>
            <div className="groupDetailsText" style={{ width: "55%" }}>
              <p>{this.dateTimeFormat(end * 1000)}</p>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div style={{ marginBottom: "10px" }}>
            <span
              style={{
                marginTop: "0px",
                marginBottom: "0px",
                fontWeight: "bold",
                fontSize: "23px",
              }}
            >
              {localizationStrings.accessHeader}
            </span>
          </div>
          <div style={{ display: "flex", width: "100%" }}>
            <div
              className="groupDetailsLabel"
              style={{ width: "45%", paddingRight: "30px" }}
            >
              <p>{localizationStrings.timeLabel}</p>
            </div>
            <div className="groupDetailsText" style={{ width: "55%" }}>
              <p>{localizationStrings.fullAccess}</p>
            </div>
          </div>
        </div>
      );
    }
  }

  isASharedMode(shareMode) {
    // normal access
    if (
      shareMode === "" ||
      shareMode === "NORMAL" ||
      shareMode === "NORMAL-GRP" ||
      shareMode == null
    ) {
      return localizationStrings.normalGrantAccess;
    } else if (shareMode === "MULTI" || shareMode === "MULTI-GRP") {
      return localizationStrings.multiApproveAccess;
    } else if (shareMode === "MULTI-OTA" || shareMode === "MULTI-OTA-GRP") {
      return localizationStrings.multiApproveOneTimeAccess;
    } else if (shareMode === "OTA" || shareMode === "OTA-GRP") {
      return localizationStrings.oneTimeAccess;
    }
    // recurring access
    else if (
      shareMode === "NORMAL-RECURR" ||
      shareMode === "NORMAL-RECURR-GRP"
    ) {
      return localizationStrings.recurringGrantAccess;
    } else if (
      shareMode === "NORMAL-RECURR-TIMED" ||
      shareMode === "NORMAL-RECURR-TIMED-GRP"
    ) {
      return localizationStrings.recurringTimedGrantAccess;
    }
  }

  dateTimeFormat(time) {
    if (localizationStrings.getLanguage() === "ja") {
      // customLog(new Intl.DateTimeFormat("ja-JP", { era: "long" }).format(time));
      // customLog(
      //   new Intl.DateTimeFormat("ja-JP", {
      //     hour: "2-digit",
      //     minute: "2-digit"
      //   }).format(time)
      // );
      // customLog(Date.now());
      var japanDate = new Intl.DateTimeFormat("ja-JP", {
        year: "numeric",
        month: "long",
        day: "numeric",
      }).format(time);
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hour: "2-digit",
        minute: "2-digit",
      }).format(time);
      return japanDate + japanTime;
    } else {
      // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
      return <TimeStamp time={time / 1000} format="full" includeDay />;
    }
  }

  timeFormat(time) {
    if (localizationStrings.getLanguage() === "ja") {
      var japanTime = new Intl.DateTimeFormat("ja-JP", {
        hour: "2-digit",
        minute: "2-digit",
      }).format(time);
      return japanTime;
    } else {
      // customLog(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(time));
      return new Intl.DateTimeFormat("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      }).format(time);
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    if (
      this.state.shareMode != undefined
        ? this.state.shareMode.includes("GRP")
        : false
    ) {
      //Group type info pop-up
      if (this.state.shareMode.includes("MULTI")) {
        return (
          <div>
            <NotificationSystem ref="notificationSystem" style={style} />
            <span
              onClick={this.handleMultiApprovalInfoPopupOpen}
              style={{ fontSize: "1.8em", width: "25px", height: "25px" }}
              data-notify="icon"
              className="pe-7s-info"
              id="detailsIcon"
            ></span>
            {/* //! Popup for Multi Approval */}
            <Modal
              show={this.state.showPopup}
              onHide={this.handleMultiApprovalInfoPopupClose}
              dialogClassName="modal-70w"
              // dialogClassName="modal-50w"
            >
              <Modal.Header closeButton>
                <Modal.Title>{localizationStrings.Header}</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: "40px 30px 60px 30px" }}>
                <div
                  className="groupSummary"
                  style={{
                    textAlign: "center",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <img
                      src={userIcon}
                      alt="user_image"
                      width="70px"
                      height="70px"
                    />
                    <h5 style={{ marginTop: "15px", fontSize: "1.3em" }}>
                      {this.isASharedMode(this.state.shareMode)}
                    </h5>
                  </div>
                </div>
                <hr />
                <div
                  className="groupDetailsContainer"
                  style={{ padding: "20px 40px" }}
                >
                  <div style={{ marginBottom: "10px" }}>
                    <span
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontWeight: "bold",
                        fontSize: "23px",
                      }}
                    >
                      {localizationStrings.Header}
                    </span>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.sharedOnLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.dateTimeFormat(this.state.sharedOn)}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", verticalAlign: "middle" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.multiApprovalLabel}</p>
                    </div>
                    <div
                      className="groupDetailsText"
                      style={{
                        width: "55%",
                        height: "100%",
                        marginTop: "auto",
                        marginBottom: "auto",
                      }}
                    >
                      <p>{this.state.multiApprovalAdmins.length}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.shareToLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.state.shareto}</p>
                    </div>
                  </div>
                  {this.getShareTime(this.state.start, this.state.end)}
                  {this.getOneTimeAccess(this.state.hasAccessed)}
                </div>
                <hr />
                <div style={{ padding: "20px 40px" }}>
                  <p style={{ fontSize: "1.2em", marginBottom: "15px" }}>
                    {localizationStrings.multiApprovalListLabel}
                  </p>
                  <BootstrapTable
                    data={this.state.multiApprovalAdmins}
                    pagination
                    options={{
                      sizePerPage: 5,
                      hideSizePerPage: true,
                      noDataText: localizationStrings.noDataTitle,
                    }}
                  >
                    <TableHeaderColumn
                      dataField="adminEmail"
                      isKey={true}
                      tdStyle={{ textAlign: "center" }}
                      thStyle={{ textAlign: "center" }}
                    >
                      {localizationStrings.emailHeader}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="access"
                      dataFormat={this.renderStatus}
                      tdStyle={{ textAlign: "center" }}
                      thStyle={{ textAlign: "center" }}
                    >
                      {localizationStrings.statusHeader}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="access"
                      dataFormat={this.renderRemarks}
                      tdStyle={{ textAlign: "center", whiteSpace: "normal" }}
                      thStyle={{ textAlign: "center" }}
                    >
                      {localizationStrings.remarkHeader}
                    </TableHeaderColumn>
                  </BootstrapTable>
                  {/* <br />
                  <br />
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                      style={{
                          backgroundColor: "#59A9F3",
                          color: "white",
                          border: "none",
                          height: "40px",
                          width: "200px",
                          borderRadius: "5px"
                        }}
                      onClick={this.handleMultiApprovalInfoPopupClose}
                    >
                      <p style={{margin: "auto", padding: "auto"}}>{localizationStrings.PopupButtonClose}</p>
                    </button>
                  </div> */}
                </div>
                <hr />
              </Modal.Body>
            </Modal>
          </div>
        );
      } else if (
        this.state.shareMode != undefined
          ? this.state.shareMode.includes("NORMAL-RECURR")
          : false
      ) {
        return (
          <div>
            <NotificationSystem ref="notificationSystem" style={style} />
            <span
              onClick={this.handleMultiApprovalInfoPopupOpen}
              style={{ fontSize: "1.8em", width: "25px", height: "25px" }}
              data-notify="icon"
              className="pe-7s-info"
              id="detailsIcon"
            ></span>
            {/* //! Popup for Grant access */}
            <Modal
              show={this.state.showPopup}
              onHide={this.handleMultiApprovalInfoPopupClose}
              dialogClassName="modal-50w"
            >
              <Modal.Header closeButton>
                <Modal.Title>{localizationStrings.Header}</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: "40px 30px 60px 30px" }}>
                <div
                  className="groupSummary"
                  style={{
                    textAlign: "center",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    {this.getShareModeIcon(this.state.shareMode)}
                    <h5 style={{ marginTop: "15px", fontSize: "1.3em" }}>
                      {this.isASharedMode(this.state.shareMode)}
                    </h5>
                  </div>
                </div>
                <hr />
                <div
                  className="groupDetailsContainer"
                  style={{ padding: "20px 40px" }}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    {/* Schedule */}
                    {/* <span className="boldFont" style={{ fontSize: "1.2em" }}>{localizationStrings.recurringSchedule}</span> */}
                    {/* Every */}
                    {/* <span className="boldFont" style={{ fontSize: "1.2em" }}>{"Every"}</span> */}
                  </div>
                  <div
                    className="responsiveBox"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      width: "100%",
                      marginBottom:
                        this.state.access.selectedRecurringTime.startTime ===
                        undefined
                          ? "40px"
                          : "20px",
                    }}
                  >
                    {/* Row display */}
                    {/* <div className="recurringBox" style={{ borderRight: "none", borderRadius: "5px 0 0 5px", backgroundColor: this.getSelectedDays(0, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(0, "fontColor") }}>Sun</span></div>
                    <div className="recurringBox" style={{ borderRight: "none", backgroundColor: this.getSelectedDays(1, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(1, "fontColor") }}>Mon</span></div>
                    <div className="recurringBox" style={{ borderRight: "none", backgroundColor: this.getSelectedDays(2, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(2, "fontColor") }}>Tue</span></div>
                    <div className="recurringBox" style={{ borderRight: "none", backgroundColor: this.getSelectedDays(3, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(3, "fontColor") }}>Wed</span></div>
                    <div className="recurringBox" style={{ borderRight: "none", backgroundColor: this.getSelectedDays(4, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(4, "fontColor") }}>Thu</span></div>
                    <div className="recurringBox" style={{ borderRight: "none", backgroundColor: this.getSelectedDays(5, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(5, "fontColor") }}>Fri</span></div>
                    <div className="recurringBox" style={{ borderRadius: "0 5px 5px 0", backgroundColor: this.getSelectedDays(6, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(6, "fontColor") }}>Sat</span></div> */}

                    {/* Circular display */}
                    {/* Flat border */}
                    {/* <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(0, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(0, "fontColor") }}>Sun</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(1, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(1, "fontColor") }}>Mon</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(2, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(2, "fontColor") }}>Tue</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(3, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(3, "fontColor") }}>Wed</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(4, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(4, "fontColor") }}>Thu</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(5, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(5, "fontColor") }}>Fri</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(6, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(6, "fontColor") }}>Sat</span></div> */}

                    {/* Card type */}
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(0, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(0, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDaySun}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(1, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(1, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDayMon}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(2, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(2, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDayTue}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(3, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(3, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDayWed}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(4, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(4, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDayThu}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(5, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(5, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDayFri}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(6, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(6, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDaySat}
                      </span>
                    </div>

                    {/* Word display */}
                    {/* Short */}
                    {/* <div className="recurringDisplay" style={{ display: this.getSelectedDays(0, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Sun</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(0, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(1, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Mon</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(1, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(2, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Tue</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(2, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(3, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Wed</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(3, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(4, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Thu</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(4, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(5, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Fri</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(5, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(6, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Sat</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(6, "bgColor") }}/></div></div> */}

                    {/* Long */}
                    {/* <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(0, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Sunday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(0, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(1, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Monday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(1, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(2, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Tuesday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(2, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(3, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Wednesday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(3, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(4, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Thursday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(4, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(5, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Friday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(5, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(6, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Saturday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(6, "bgColor") }}/></div></div> */}

                    {/* Card display */}
                    {/* Long Day */}
                    {/* <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(0, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(0, "fontColor"), textAlign: "center" }}>Every Sunday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(1, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(1, "fontColor"), textAlign: "center" }}>Every Monday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(2, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(2, "fontColor"), textAlign: "center" }}>Every Tuesday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(3, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(3, "fontColor"), textAlign: "center" }}>Every Wednesday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(4, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(4, "fontColor"), textAlign: "center" }}>Every Thursday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(5, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(5, "fontColor"), textAlign: "center" }}>Every Friday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(6, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(6, "fontColor"), textAlign: "center" }}>Every Saturday</span></div> */}

                    {/* Short Day */}
                    {/* <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(0, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(0, "fontColor"), textAlign: "center" }}>Every Sun</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(1, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(1, "fontColor"), textAlign: "center" }}>Every Mon</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(2, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(2, "fontColor"), textAlign: "center" }}>Every Tue</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(3, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(3, "fontColor"), textAlign: "center" }}>Every Wed</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(4, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(4, "fontColor"), textAlign: "center" }}>Every Thu</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(5, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(5, "fontColor"), textAlign: "center" }}>Every Fri</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(6, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(6, "fontColor"), textAlign: "center" }}>Every Sat</span></div> */}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display:
                        this.state.access.selectedRecurringTime.startTime ===
                        undefined
                          ? "none"
                          : "flex",
                      justifyContent: "center",
                      margin: "20px 0 10px 0",
                    }}
                  >
                    <p>
                      {this.state.access.selectedRecurringTime.startTime ===
                      undefined
                        ? ""
                        : this.timeFormat(
                            (this.state.access.selectedRecurringTime.startTime -
                              this.state.access.selectedRecurringTime.offset +
                              1800) *
                              1000,
                          ) +
                          localizationStrings.recurringTimeLabel1 +
                          this.timeFormat(
                            (this.state.access.selectedRecurringTime.endTime -
                              this.state.access.selectedRecurringTime.offset +
                              1800) *
                              1000,
                          ) +
                          localizationStrings.recurringTimeLabel2}
                    </p>
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    <span
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontWeight: "bold",
                        fontSize: "23px",
                      }}
                    >
                      {localizationStrings.Header}
                    </span>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.sharedOnLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.dateTimeFormat(this.state.sharedOn)}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.lockLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.state.name}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.shareToLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.state.shareto}</p>
                    </div>
                  </div>
                  {this.getShareTime(this.state.start, this.state.end)}
                  {this.getOneTimeAccess(this.state.hasAccessed)}
                  {this.getAccessTime()}
                </div>
                <hr />
                {/* <div style={{ padding: "20px 40px" }}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                      style={{
                          backgroundColor: "#59A9F3",
                          color: "white",
                          border: "none",
                          height: "40px",
                          width: "200px",
                          borderRadius: "5px"
                        }}
                      onClick={this.handleMultiApprovalInfoPopupClose}
                    >
                      <p style={{margin: "auto", padding: "auto"}}>{localizationStrings.PopupButtonClose}</p>
                    </button>
                  </div>
                </div> */}
              </Modal.Body>
            </Modal>
          </div>
        );
      } else {
        return (
          <div>
            <NotificationSystem ref="notificationSystem" style={style} />
            <span
              onClick={this.handleMultiApprovalInfoPopupOpen}
              style={{ fontSize: "1.8em", width: "25px", height: "25px" }}
              data-notify="icon"
              className="pe-7s-info"
              id="detailsIcon"
            ></span>
            {/* //! Popup for Grant access */}
            <Modal
              show={this.state.showPopup}
              onHide={this.handleMultiApprovalInfoPopupClose}
              dialogClassName="modal-50w"
            >
              <Modal.Header closeButton>
                <Modal.Title>{localizationStrings.Header}</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: "40px 30px 60px 30px" }}>
                <div
                  className="groupSummary"
                  style={{
                    textAlign: "center",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    {this.getShareModeIcon(this.state.shareMode)}
                    <h5 style={{ marginTop: "15px", fontSize: "1.3em" }}>
                      {this.isASharedMode(this.state.shareMode)}
                    </h5>
                  </div>
                </div>
                <hr />
                <div
                  className="groupDetailsContainer"
                  style={{ padding: "20px 40px" }}
                >
                  <div style={{ marginBottom: "10px" }}>
                    <span
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontWeight: "bold",
                        fontSize: "23px",
                      }}
                    >
                      {localizationStrings.Header}
                    </span>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.sharedOnLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.dateTimeFormat(this.state.sharedOn)}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.lockLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.state.name}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.shareToLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.state.shareto}</p>
                    </div>
                  </div>
                  {this.getShareTime(this.state.start, this.state.end)}
                  {this.getOneTimeAccess(this.state.hasAccessed)}
                </div>
                <hr />
                {/* <div style={{ padding: "20px 40px" }}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                      style={{
                          backgroundColor: "#59A9F3",
                          color: "white",
                          border: "none",
                          height: "40px",
                          width: "200px",
                          borderRadius: "5px"
                        }}
                      onClick={this.handleMultiApprovalInfoPopupClose}
                    >
                      <p style={{margin: "auto", padding: "auto"}}>{localizationStrings.PopupButtonClose}</p>
                    </button>
                  </div>
                </div> */}
              </Modal.Body>
            </Modal>
          </div>
        );
      }
    } else {
      //Individual type info pop-up
      if (
        this.state.shareMode != undefined
          ? this.state.shareMode.includes("MULTI")
          : false
      ) {
        return (
          <div>
            <NotificationSystem ref="notificationSystem" style={style} />
            <span
              onClick={this.handleMultiApprovalInfoPopupOpen}
              style={{ fontSize: "1.8em", width: "25px", height: "25px" }}
              data-notify="icon"
              className="pe-7s-info"
              id="detailsIcon"
            ></span>
            {/* //! Popup for Multi Approval */}
            <Modal
              show={this.state.showPopup}
              onHide={this.handleMultiApprovalInfoPopupClose}
              dialogClassName="modal-70w"
              // dialogClassName="modal-50w"
            >
              <Modal.Header closeButton>
                <Modal.Title>{localizationStrings.Header}</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: "40px 30px 60px 30px" }}>
                <div
                  className="groupSummary"
                  style={{
                    textAlign: "center",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <img
                      src={userIcon}
                      alt="user_image"
                      width="70px"
                      height="70px"
                    />
                    <h5 style={{ marginTop: "15px", fontSize: "1.3em" }}>
                      {this.isASharedMode(this.state.shareMode)}
                    </h5>
                  </div>
                </div>
                <hr />
                <div
                  className="groupDetailsContainer"
                  style={{ padding: "20px 40px" }}
                >
                  <div style={{ marginBottom: "10px" }}>
                    <span
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontWeight: "bold",
                        fontSize: "23px",
                      }}
                    >
                      {localizationStrings.Header}
                    </span>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.sharedOnLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.dateTimeFormat(this.state.sharedOn)}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", verticalAlign: "middle" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.multiApprovalLabel}</p>
                    </div>
                    <div
                      className="groupDetailsText"
                      style={{
                        width: "55%",
                        height: "100%",
                        marginTop: "auto",
                        marginBottom: "auto",
                      }}
                    >
                      <p>{this.state.multiApprovalAdmins.length}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.shareToLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.state.shareto}</p>
                    </div>
                  </div>
                  {this.getShareTime(this.state.start, this.state.end)}
                  {this.getOneTimeAccess(this.state.hasAccessed)}
                </div>
                <hr />
                <div style={{ padding: "20px 40px" }}>
                  <p style={{ fontSize: "1.2em", marginBottom: "15px" }}>
                    {localizationStrings.multiApprovalListLabel}
                  </p>
                  <BootstrapTable
                    data={this.state.multiApprovalAdmins}
                    pagination
                    options={{
                      sizePerPage: 5,
                      hideSizePerPage: true,
                      noDataText: localizationStrings.noDataTitle,
                    }}
                  >
                    <TableHeaderColumn
                      dataField="adminEmail"
                      isKey={true}
                      tdStyle={{ textAlign: "center" }}
                      thStyle={{ textAlign: "center" }}
                    >
                      {localizationStrings.emailHeader}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="access"
                      dataFormat={this.renderStatus}
                      tdStyle={{ textAlign: "center" }}
                      thStyle={{ textAlign: "center" }}
                    >
                      {localizationStrings.statusHeader}
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      dataField="access"
                      dataFormat={this.renderRemarks}
                      tdStyle={{ textAlign: "center", whiteSpace: "normal" }}
                      thStyle={{ textAlign: "center" }}
                    >
                      {localizationStrings.remarkHeader}
                    </TableHeaderColumn>
                  </BootstrapTable>
                  {/* <br />
                  <br />
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                      style={{
                          backgroundColor: "#59A9F3",
                          color: "white",
                          border: "none",
                          height: "40px",
                          width: "200px",
                          borderRadius: "5px"
                        }}
                      onClick={this.handleMultiApprovalInfoPopupClose}
                    >
                      <p style={{margin: "auto", padding: "auto"}}>{localizationStrings.PopupButtonClose}</p>
                    </button>
                  </div> */}
                </div>
                <hr />
              </Modal.Body>
            </Modal>
          </div>
        );
      } else if (
        this.state.shareMode != undefined
          ? this.state.shareMode.includes("NORMAL-RECURR")
          : false
      ) {
        return (
          <div>
            <NotificationSystem ref="notificationSystem" style={style} />
            <span
              onClick={this.handleMultiApprovalInfoPopupOpen}
              style={{ fontSize: "1.8em", width: "25px", height: "25px" }}
              data-notify="icon"
              className="pe-7s-info"
              id="detailsIcon"
            ></span>
            {/* //! Popup for Grant access */}
            <Modal
              show={this.state.showPopup}
              onHide={this.handleMultiApprovalInfoPopupClose}
              dialogClassName="modal-50w"
            >
              <Modal.Header closeButton>
                <Modal.Title>{localizationStrings.Header}</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: "40px 30px 60px 30px" }}>
                <div
                  className="groupSummary"
                  style={{
                    textAlign: "center",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    {this.getShareModeIcon(this.state.shareMode)}
                    <h5 style={{ marginTop: "15px", fontSize: "1.3em" }}>
                      {this.isASharedMode(this.state.shareMode)}
                    </h5>
                  </div>
                </div>
                <hr />
                <div
                  className="groupDetailsContainer"
                  style={{ padding: "20px 40px" }}
                >
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    {/* Schedule */}
                    {/* <span className="boldFont" style={{ fontSize: "1.2em" }}>{localizationStrings.recurringSchedule}</span> */}
                    {/* Every */}
                    {/* <span className="boldFont" style={{ fontSize: "1.2em" }}>{"Every"}</span> */}
                  </div>
                  <div
                    className="responsiveBox"
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                      width: "100%",
                      marginBottom:
                        this.state.access.selectedRecurringTime.startTime ===
                        undefined
                          ? "40px"
                          : "20px",
                    }}
                  >
                    {/* Row display */}
                    {/* <div className="recurringBox" style={{ borderRight: "none", borderRadius: "5px 0 0 5px", backgroundColor: this.getSelectedDays(0, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(0, "fontColor") }}>Sun</span></div>
                    <div className="recurringBox" style={{ borderRight: "none", backgroundColor: this.getSelectedDays(1, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(1, "fontColor") }}>Mon</span></div>
                    <div className="recurringBox" style={{ borderRight: "none", backgroundColor: this.getSelectedDays(2, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(2, "fontColor") }}>Tue</span></div>
                    <div className="recurringBox" style={{ borderRight: "none", backgroundColor: this.getSelectedDays(3, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(3, "fontColor") }}>Wed</span></div>
                    <div className="recurringBox" style={{ borderRight: "none", backgroundColor: this.getSelectedDays(4, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(4, "fontColor") }}>Thu</span></div>
                    <div className="recurringBox" style={{ borderRight: "none", backgroundColor: this.getSelectedDays(5, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(5, "fontColor") }}>Fri</span></div>
                    <div className="recurringBox" style={{ borderRadius: "0 5px 5px 0", backgroundColor: this.getSelectedDays(6, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(6, "fontColor") }}>Sat</span></div> */}

                    {/* Circular display */}
                    {/* Flat border */}
                    {/* <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(0, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(0, "fontColor") }}>Sun</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(1, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(1, "fontColor") }}>Mon</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(2, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(2, "fontColor") }}>Tue</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(3, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(3, "fontColor") }}>Wed</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(4, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(4, "fontColor") }}>Thu</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(5, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(5, "fontColor") }}>Fri</span></div>
                    <div className="recurringCircular" style={{ borderRadius: "30px 30px 30px 30px", backgroundColor: this.getSelectedDays(6, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(6, "fontColor") }}>Sat</span></div> */}

                    {/* Card type */}
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(0, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(0, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDaySun}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(1, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(1, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDayMon}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(2, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(2, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDayTue}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(3, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(3, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDayWed}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(4, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(4, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDayThu}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(5, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(5, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDayFri}
                      </span>
                    </div>
                    <div
                      className="recurringCircular circularCard"
                      style={{
                        borderRadius: "30px 30px 30px 30px",
                        backgroundColor: this.getSelectedDays(6, "bgColor"),
                        margin: "0 10px 0 10px",
                      }}
                    >
                      <span
                        className="boldFont"
                        style={{
                          fontSize:
                            localizationStrings.getLanguage() === "ja"
                              ? "1.5em"
                              : "1.2em",
                          color: this.getSelectedDays(6, "fontColor"),
                        }}
                      >
                        {localizationStrings.recurringDaySat}
                      </span>
                    </div>

                    {/* Word display */}
                    {/* Short */}
                    {/* <div className="recurringDisplay" style={{ display: this.getSelectedDays(0, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Sun</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(0, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(1, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Mon</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(1, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(2, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Tue</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(2, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(3, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Wed</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(3, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(4, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Thu</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(4, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(5, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Fri</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(5, "bgColor") }}/></div></div>
                    <div className="recurringDisplay" style={{ display: this.getSelectedDays(6, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Sat</span></div><div style={{ display: "flex", height: "30px", width: "60px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(6, "bgColor") }}/></div></div> */}

                    {/* Long */}
                    {/* <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(0, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Sunday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(0, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(1, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Monday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(1, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(2, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Tuesday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(2, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(3, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Wednesday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(3, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(4, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Thursday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(4, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(5, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Friday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(5, "bgColor") }}/></div></div>
                    <div className="recurringDisplayLong" style={{ display: this.getSelectedDays(6, "display"), margin: "0 10px 0 10px" }}><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", borderBottom: "1px solid black" }}><span className="boldFont" style={{ fontSize: "1.2em", color: "#3C3E41" }}>Saturday</span></div><div style={{ display: "flex", height: "30px", width: "120px", justifyContent: "center", alignItems: "center" }}><div style={{ height: "10px", width: "10px", borderRadius: "5px 5px 5px 5px", backgroundColor: this.getSelectedDays(6, "bgColor") }}/></div></div> */}

                    {/* Card display */}
                    {/* Long Day */}
                    {/* <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(0, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(0, "fontColor"), textAlign: "center" }}>Every Sunday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(1, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(1, "fontColor"), textAlign: "center" }}>Every Monday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(2, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(2, "fontColor"), textAlign: "center" }}>Every Tuesday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(3, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(3, "fontColor"), textAlign: "center" }}>Every Wednesday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(4, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(4, "fontColor"), textAlign: "center" }}>Every Thursday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(5, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(5, "fontColor"), textAlign: "center" }}>Every Friday</span></div>
                    <div className="recurringCard" style={{ borderRadius: "10px 10px 10px 10px", backgroundColor: this.getSelectedDays(6, "bgColor"), margin: "0 10px 0 10px" }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(6, "fontColor"), textAlign: "center" }}>Every Saturday</span></div> */}

                    {/* Short Day */}
                    {/* <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(0, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(0, "fontColor"), textAlign: "center" }}>Every Sun</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(1, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(1, "fontColor"), textAlign: "center" }}>Every Mon</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(2, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(2, "fontColor"), textAlign: "center" }}>Every Tue</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(3, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(3, "fontColor"), textAlign: "center" }}>Every Wed</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(4, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(4, "fontColor"), textAlign: "center" }}>Every Thu</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(5, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(5, "fontColor"), textAlign: "center" }}>Every Fri</span></div>
                    <div className="recurringCard" style={{ backgroundColor: this.getSelectedDays(6, "bgColor") }}><span className="boldFont" style={{ fontSize: "1.2em", color: this.getSelectedDays(6, "fontColor"), textAlign: "center" }}>Every Sat</span></div> */}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display:
                        this.state.access.selectedRecurringTime.startTime ===
                        undefined
                          ? "none"
                          : "flex",
                      justifyContent: "center",
                      margin: "20px 0 10px 0",
                    }}
                  >
                    <p>
                      {this.state.access.selectedRecurringTime.startTime ===
                      undefined
                        ? ""
                        : this.timeFormat(
                            (this.state.access.selectedRecurringTime.startTime -
                              this.state.access.selectedRecurringTime.offset +
                              1800) *
                              1000,
                          ) +
                          localizationStrings.recurringTimeLabel1 +
                          this.timeFormat(
                            (this.state.access.selectedRecurringTime.endTime -
                              this.state.access.selectedRecurringTime.offset +
                              1800) *
                              1000,
                          ) +
                          localizationStrings.recurringTimeLabel2}
                    </p>
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    <span
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontWeight: "bold",
                        fontSize: "23px",
                      }}
                    >
                      {localizationStrings.Header}
                    </span>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.sharedOnLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.dateTimeFormat(this.state.sharedOn)}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.lockLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.state.name}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.shareToLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.state.shareto}</p>
                    </div>
                  </div>
                  {this.getShareTime(this.state.start, this.state.end)}
                  {this.getOneTimeAccess(this.state.hasAccessed)}
                  {this.getAccessTime()}
                </div>
                <hr />
                {/* <div style={{ padding: "20px 40px" }}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                      style={{
                          backgroundColor: "#59A9F3",
                          color: "white",
                          border: "none",
                          height: "40px",
                          width: "200px",
                          borderRadius: "5px"
                        }}
                      onClick={this.handleMultiApprovalInfoPopupClose}
                    >
                      <p style={{margin: "auto", padding: "auto"}}>{localizationStrings.PopupButtonClose}</p>
                    </button>
                  </div>
                </div> */}
              </Modal.Body>
            </Modal>
          </div>
        );
      } else {
        return (
          <div>
            <NotificationSystem ref="notificationSystem" style={style} />
            <span
              onClick={this.handleMultiApprovalInfoPopupOpen}
              style={{ fontSize: "1.8em", width: "25px", height: "25px" }}
              data-notify="icon"
              className="pe-7s-info"
              id="detailsIcon"
            ></span>
            {/* //! Popup for Grant access */}
            <Modal
              show={this.state.showPopup}
              onHide={this.handleMultiApprovalInfoPopupClose}
              dialogClassName="modal-50w"
            >
              <Modal.Header closeButton>
                <Modal.Title>{localizationStrings.Header}</Modal.Title>
              </Modal.Header>
              <Modal.Body style={{ padding: "40px 30px 60px 30px" }}>
                <div
                  className="groupSummary"
                  style={{
                    textAlign: "center",
                    display: "flex",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    {this.getShareModeIcon(this.state.shareMode)}
                    <h5 style={{ marginTop: "15px", fontSize: "1.3em" }}>
                      {this.isASharedMode(this.state.shareMode)}
                    </h5>
                  </div>
                </div>
                <hr />
                <div
                  className="groupDetailsContainer"
                  style={{ padding: "20px 40px" }}
                >
                  <div style={{ marginBottom: "10px" }}>
                    <span
                      style={{
                        marginTop: "0px",
                        marginBottom: "0px",
                        fontWeight: "bold",
                        fontSize: "23px",
                      }}
                    >
                      {localizationStrings.Header}
                    </span>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.sharedOnLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.dateTimeFormat(this.state.sharedOn)}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.lockLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.state.name}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", width: "100%" }}>
                    <div
                      className="groupDetailsLabel"
                      style={{ width: "45%", paddingRight: "30px" }}
                    >
                      <p>{localizationStrings.shareToLabel}</p>
                    </div>
                    <div className="groupDetailsText" style={{ width: "55%" }}>
                      <p>{this.state.shareto}</p>
                    </div>
                  </div>
                  {this.getShareTime(this.state.start, this.state.end)}
                  {this.getOneTimeAccess(this.state.hasAccessed)}
                </div>
                <hr />
                {/* <div style={{ padding: "20px 40px" }}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                      style={{
                          backgroundColor: "#59A9F3",
                          color: "white",
                          border: "none",
                          height: "40px",
                          width: "200px",
                          borderRadius: "5px"
                        }}
                      onClick={this.handleMultiApprovalInfoPopupClose}
                    >
                      <p style={{margin: "auto", padding: "auto"}}>{localizationStrings.PopupButtonClose}</p>
                    </button>
                  </div>
                </div> */}
              </Modal.Body>
            </Modal>
          </div>
        );
      }
    }
  }
}

export default MultiApprovalInfo;
